import { render, staticRenderFns } from "./KlarnaPaymentMethod.vue?vue&type=template&id=18ee0a4a&scoped=true"
import script from "./KlarnaPaymentMethod.vue?vue&type=script&lang=js"
export * from "./KlarnaPaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee0a4a",
  null
  
)

export default component.exports